import { t } from '@exam-prep/i18n';
import { Button } from '@exam-prep/ui';
import { EXAM } from '../../exam-guard';

export function PlayerFooter({
  confirm,
  counts,
  managed,
  lastUnit,
  transitioning,
  onAsk,
  onCancel,
  onConfirm,
}: {
  confirm: 'submit' | 'next' | null;
  counts: { answered: number; marked: number; left: number };
  managed: boolean;
  lastUnit: boolean;
  transitioning: boolean;
  onAsk: (action: 'submit' | 'next') => void;
  onCancel: () => void;
  onConfirm: (action: 'submit' | 'next') => void;
}) {
  return (
    <footer className="glass-bar sticky bottom-0 space-y-2 border-t p-3">
      {confirm ? (
        <div className="space-y-2 text-sm">
          <p>
            {confirm === 'submit'
              ? t('miniapp.player.confirm', counts) + (managed ? ` ${EXAM.oneAttempt}` : '')
              : t('miniapp.player.next_part_confirm')}
          </p>
          <div className="flex gap-2">
            <Button
              variant="outline"
              className="flex-1"
              aria-label={t('miniapp.cancel')}
              disabled={transitioning}
              onClick={onCancel}
            >
              ✕
            </Button>
            <Button
              aria-label={t('miniapp.confirm')}
              className="flex-1"
              disabled={transitioning}
              onClick={() => onConfirm(confirm)}
            >
              ✓
            </Button>
          </div>
        </div>
      ) : (
        <div className="flex gap-2">
          {!lastUnit ? (
            <Button variant="outline" className="flex-1" onClick={() => onAsk('next')}>
              {t('miniapp.player.next_part')}
            </Button>
          ) : null}
          <Button className="flex-1" onClick={() => onAsk('submit')}>
            {t('miniapp.player.submit')}
          </Button>
        </div>
      )}
    </footer>
  );
}
